/**
 * Topbar Scroll Functionality
 * Handles topbar appearance changes when scrolling
 */

export function initTopbar() {
	const siteTopbar = document.getElementById('site-topbar');
	const primaryMenu = document.getElementById('primary-menu');
	const languageSwitcher = siteTopbar?.querySelector('[x-data="{ open: false }"] button');
	const mainLogo = document.getElementById('main-logo');
	const scrolledLogo = document.getElementById('scrolled-logo');
	
	function handleScroll() {
		const scrolled = window.scrollY > 100;
		
		if (scrolled) {
			// Change to white background after scrolling 100px
			siteTopbar.classList.remove('before:bg-gradient-to-b', 'before:from-black/50', 'before:to-transparent');
			siteTopbar.classList.add('before:bg-white/95', 'outline-1', 'outline-primary/25');
			
			// Hide main logo and show smaller logo
			if (mainLogo) {
				mainLogo.classList.add('opacity-0', 'invisible', '-translate-y-8');
			}
			if (scrolledLogo) {
				scrolledLogo.classList.remove('opacity-0', 'invisible');
				scrolledLogo.classList.add('opacity-100', 'visible');
			}
			
			// Change navigation text to dark
			if (primaryMenu) {
				primaryMenu.classList.remove('[&_a]:text-white');
				primaryMenu.classList.add('[&_a]:text-dark');
			}
			
			// Change language switcher text to dark
			if (languageSwitcher) {
				languageSwitcher.classList.remove('text-white');
				languageSwitcher.classList.add('text-dark');
			}
		} else {
			// Restore gradient background when at top
			siteTopbar.classList.remove('before:bg-white/95', 'outline-1', 'outline-primary/25');
			siteTopbar.classList.add('before:bg-gradient-to-b', 'before:from-black/50', 'before:to-transparent');
			
			// Show main logo and hide smaller logo
			if (mainLogo) {
				mainLogo.classList.remove('opacity-0', 'invisible', '-translate-y-8');
			}

			if (scrolledLogo) {
				scrolledLogo.classList.add('opacity-0', 'invisible');
				scrolledLogo.classList.remove('opacity-100', 'visible');
			}
			
			// Restore navigation text to white
			if (primaryMenu) {
				primaryMenu.classList.remove('[&_a]:text-dark');
				primaryMenu.classList.add('[&_a]:text-white');
			}
			
			// Restore language switcher text to white
			if (languageSwitcher) {
				languageSwitcher.classList.remove('text-dark');
				languageSwitcher.classList.add('text-white');
			}
		}
	}
	
	// Handle scroll events
	if (siteTopbar) {
		window.addEventListener('scroll', handleScroll);
	}
}